$(function() {

    $.archaeologist = {};

    $.archaeologist.delayFadeOut = true;

    $.archaeologist.lastProfile = true;

    // durations

    $.archaeologist.duration = '75%';

    $.archaeologist.calculatePinDuration = function() {
        var contentHeight = $('#archaeologist-container .content-container').outerHeight();
        if ($.archaeologist.lastProfile) {
            $.archaeologist.pinDuration = 0;
        } else {
            $.archaeologist.pinDuration = Math.round(contentHeight + $(window).innerHeight());
        }
        return $.archaeologist.pinDuration;
	};

    $.archaeologist.zoomDuration = '100%';

    $.archaeologist.endDuration = ($.archaeologist.delayFadeOut) ? '150%' : '50%';

    // timelines

    $.archaeologist.tl = {};

    // in

	$.archaeologist.tl.in = new TimelineMax();

    $.archaeologist.tl.in.addLabel("start");

    $.archaeologist.tl.in.set("#archaeologist-container", { visibility: "visible" }, "start");﻿

    if (!$.ms) {

        $.archaeologist.tl.in.from("#archaeologist-svg .line-1", 1, { x:"2560" }, "start");
        $.archaeologist.tl.in.from("#archaeologist-svg .line-2", 1, { x:"2560", delay: 0.25 }, "start");
        $.archaeologist.tl.in.from("#archaeologist-svg .line-3", 1, { x:"2560", delay: 0.5 }, "start");
        $.archaeologist.tl.in.add(function(){ /* pause */ }, "+=0.25");

        new ScrollMagic.Scene({ triggerElement: '#archaeologist-in', triggerHook: 'onEnter', duration: $.archaeologist.duration })
        	.setTween($.archaeologist.tl.in)
        	// .addIndicators({name: 'archaeologist in'})
        	.addTo($.controller);

    }

    // pin

    new ScrollMagic.Scene({ triggerElement: '#archaeologist-pin', triggerHook: 'onLeave', duration: $.archaeologist.calculatePinDuration })
        .setPin('#archaeologist-container .svg-background')
        // .addIndicators({name: 'archaeologist pin'})
        .addTo($.controller);

    // zoom

    $.archaeologist.zoom = {};

    $.archaeologist.tl.zoom = new TimelineMax();

    $.archaeologist.tl.zoom.addLabel("start");
    $.archaeologist.tl.zoom.addLabel("content", 2);

    if ($.ms || ($.windowWidth > $.breakpoint.e3 && $.safari)) { // zoom

        $.archaeologist.tl.zoom.to("#archaeologist-svg .svg-text", 2, { y:"-320" }, "start");

    } else {

        $.archaeologist.zoom.scale = 10;
        $.archaeologist.zoom.offset = $.archaeologist.zoom.scale * 100 / 2;
        $.archaeologist.zoom.xy = "-"+ $.archaeologist.zoom.offset +"%";

        $.archaeologist.tl.zoom.to("#archaeologist-svg .svg-text", 2, { x:$.archaeologist.zoom.xy, y:$.archaeologist.zoom.xy, scaleX:$.archaeologist.zoom.scale, scaleY:$.archaeologist.zoom.scale, force3D:true }, "start");

    }

    $.archaeologist.tl.zoom.to("#archaeologist-container .svg-img-overlay-mask", 0.5, { opacity:0 }, "start");
    $.archaeologist.tl.zoom.to("#archaeologist-background", 0.5, { backgroundColor:$.color.black, delay:1 }, "start");
    $.archaeologist.tl.zoom.fromTo("#archaeologist-svg .svg-img .img-default", 0.5, { opacity:0 }, { opacity:1, delay:1.5 }, "start");
    $.archaeologist.tl.zoom.set("#archaeologist-svg .svg-bg", { visibility:"hidden", delay:2 }, "start");﻿
    $.archaeologist.tl.zoom.set("#archaeologist-svg .svg-img-mask", { visibility:"hidden", delay:2 }, "start");﻿

    $.archaeologist.tl.zoom.fromTo("#archaeologist-container .svg-img-overlay", 0.5, { opacity:0 }, { opacity:1 }, "content");
    $.archaeologist.tl.zoom.fromTo("#archaeologist-container .svg-content-overlay", 0.5, { opacity:0 }, { opacity:1 }, "content");
    if ($.windowWidth > $.breakpoint.lg) {
        $.archaeologist.tl.zoom.fromTo("#archaeologist-container .svg-content-overlay", 0.5, { x:"-100%" }, { x:"0%" }, "content");
    }
    $.archaeologist.tl.zoom.fromTo("#archaeologist-container .content-container", 0.5, { opacity:0 }, { opacity:1, delay:0.5 }, "content");

    new ScrollMagic.Scene({ triggerElement: '#archaeologist-zoom', triggerHook: 'onCenter', duration: $.archaeologist.zoomDuration })
        .on('start', function () {
            $.archaeologist.tl.in.seek($.archaeologist.tl.in.duration(), false);
        })
        .setTween($.archaeologist.tl.zoom)
        // .addIndicators({name: 'archaeologist zoom'})
        .addTo($.controller);

    $.archaeologist.tl.out = new TimelineMax();

    $.archaeologist.tl.out.addLabel("start");

    $.archaeologist.tl.out.to("#archaeologist-container .content-container", 1, { opacity:0 }, "start");

    if ($.archaeologist.delayFadeOut) {
        $.archaeologist.tl.out.to("#archaeologist-background", 1, { opacity:0, delay:2 }, "start");
    } else {
        $.archaeologist.tl.out.to("#archaeologist-background", 1, { opacity:0 }, "start");
    }

    new ScrollMagic.Scene({ triggerElement: '#archaeologist-end', triggerHook: 'onCenter', duration: $.archaeologist.endDuration })
        .setTween($.archaeologist.tl.out)
        // .addIndicators({name: 'archaeologist out'})
        .addTo($.controller);

});
